/**
 * Configuration for API host and authentication.
 * Local dev: Uses REACT_APP_API_BASE_URL and REACT_APP_SALESFORCE_REDIRECT_URI from .env
 * Production: Empty REACT_APP_API_BASE_URL makes API calls relative paths handled by Azure REACT_APP_SALESFORCE_REDIRECT_URI uses production URL
 */
const config = {
  // API Configuration - empty in production for relative paths
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "",
  REACT_APP_SALESFORCE_REDIRECT_URI: process.env.REACT_APP_SALESFORCE_REDIRECT_URI || "https://dashboard.elion.be",

  // Salesforce OAuth Configuration - Fixed for all environments
  REACT_APP_SALESFORCE_AUTHORIZATION_ENDPOINT: "https://klant.elindus.be/services/oauth2/authorize",
  REACT_APP_SALESFORCE_CLIENT_ID: "3MVG98_Psg5cppybYBR_rfLR4ao9_1wSWXNAec5JG7SHIfr8BpJTCuEIATA2oQ8O4Kpn_tSnKBhwZLdmUl5EU",
  REACT_APP_SALESFORCE_TOKEN_ENDPOINT: "https://klant.elindus.be/services/oauth2/token"
};

export default config;
